import {
	Dialog,
	AppBar,
	Toolbar,
	Typography,
	IconButton,
	DialogContent,
	Table,
	TableBody,
	TableRow,
	TableCell,
	TableContainer,
	TableHead,
	Button,
	FormControlLabel,
	Divider,
	DialogActions,
	Box,
	Tab,
	Tabs,
} from '@mui/material'
import { TextField, Checkbox } from '@mui/material'
import TransitionEffect from './TransitionEffect'
import CloseIcon from '@mui/icons-material/Close'
import { useEffect, useState } from 'react'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
interface TabPanelProps {
	children?: React.ReactNode
	index: number
	value: number
}

function CustomTabPanel(props: TabPanelProps) {
	const { children, value, index, ...other } = props

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <Box sx={{ p: 3 }}>{children}</Box>}
		</div>
	)
}

const SlideBlockPopup = ({
	popupOpen,
	popupData,
	setPopupData,
	selectedSbList,
	sbList,
	onPopupClose,
	onSBItemClick,
	onPopupSubmit,
}: {
	popupOpen: boolean
	popupData: any
	setPopupData: any
	selectedSbList: any[]
	sbList: any[]
	onPopupClose: () => void
	onSBItemClick: any
	onPopupSubmit: () => void
}) => {
	const [isLgUp, setIsLgUp] = useState<boolean>(false)
	const [value, setValue] = useState('1')

	const handleChange = (event: React.SyntheticEvent, newValue: string) => {
		setValue(newValue)
	}

	const [tab1Dataset, setTab1Dataset] = useState<any[]>([])
	const [tab2Dataset, setTab2Dataset] = useState<any[]>([])
	const [tab3Dataset, setTab3Dataset] = useState<any[]>([])
	const [tab4Dataset, setTab4Dataset] = useState<any[]>([])

	useEffect(() => {
		// Sequence 9000 ~ 9010
		const tab1Data = sbList.filter((item: any) => {
			return item.Sequence >= 9000 && item.Sequence <= 9010
		})
		// Sequence 9011 ~ 9022
		const tab2Data = sbList.filter((item: any) => {
			return item.Sequence >= 9011 && item.Sequence <= 9022
		})
		// Sequence 9027 ~ 9030
		const tab3Data = sbList.filter((item: any) => {
			return item.Sequence >= 9027 && item.Sequence <= 9030
		})
		// Sequence 9031 ~ 9032
		const tab4Data = sbList.filter((item: any) => {
			return item.Sequence >= 9031 && item.Sequence <= 9032
		})

		setTab1Dataset(tab1Data)
		setTab2Dataset(tab2Data)
		setTab3Dataset(tab3Data)
		setTab4Dataset(tab4Data)
	}, [sbList])

	useEffect(() => {
		const resizeListener = () => {
			setIsLgUp(window.innerWidth >= 1024) // Assuming 1024px is the breakpoint for large screens
		}
		resizeListener() // Initial check
		window.addEventListener('resize', resizeListener)
		return () => {
			window.removeEventListener('resize', resizeListener)
		}
	}, [])

	return (
		<Dialog
			open={popupOpen}
			onClose={onPopupClose}
			TransitionComponent={TransitionEffect}
			fullWidth
		>
			<AppBar
				sx={{ position: 'sticky' }}
				className="noPrint"
			>
				<Toolbar>
					<Typography
						sx={{ flex: 1 }}
						variant="h6"
						component="p"
					>
						Slide/Block 외부반출 신청
					</Typography>
					<IconButton
						edge="end"
						color="inherit"
						aria-label="close"
						onClick={onPopupClose}
					>
						<CloseIcon />
					</IconButton>
				</Toolbar>
			</AppBar>
			<DialogContent>
				<Typography
					variant="body1"
					gutterBottom
				>
					* 접수정보
				</Typography>
				<Table
					size="small"
					sx={{
						mb: 2,
						border: '1px solid rgba(224, 224, 224, 1)',
					}}
				>
					<colgroup>
						<col style={{ width: 95 }} />
						<col style={{ width: 170 }} />
						<col style={{ width: 95 }} />
						<col />
					</colgroup>
					<TableBody>
						<TableRow>
							<TableCell
								sx={{
									backgroundColor: 'rgb(227, 242, 253)',
									textAlign: 'center',
									fontSize: isLgUp ? '1rem' : '0.6rem',
								}}
							>
								의뢰기관명
							</TableCell>
							<TableCell
								sx={{
									fontSize: isLgUp ? '1rem' : '0.6rem',
								}}
							>
								{popupData?.ClientName}
							</TableCell>
							<TableCell
								sx={{
									backgroundColor: 'rgb(227, 242, 253)',
									textAlign: 'center',
									fontSize: isLgUp ? '1rem' : '0.6rem',
								}}
							>
								접수일자
							</TableCell>
							<TableCell
								sx={{
									fontSize: isLgUp ? '1rem' : '0.6rem',
								}}
							>
								{popupData?.ReceptionDate}
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell
								sx={{
									backgroundColor: 'rgb(227, 242, 253)',
									textAlign: 'center',
									fontSize: isLgUp ? '1rem' : '0.6rem',
								}}
							>
								수진자명
							</TableCell>
							<TableCell
								sx={{
									fontSize: isLgUp ? '1rem' : '0.6rem',
								}}
							>
								{popupData?.PatientName}
							</TableCell>
							<TableCell
								sx={{
									backgroundColor: 'rgb(227, 242, 253)',
									textAlign: 'center',
									fontSize: isLgUp ? '1rem' : '0.6rem',
								}}
							>
								성별/나이
							</TableCell>
							<TableCell
								sx={{
									fontSize: isLgUp ? '1rem' : '0.6rem',
								}}
							>
								{popupData?.ClientInfo}
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell
								sx={{
									backgroundColor: 'rgb(227, 242, 253)',
									textAlign: 'center',
									fontSize: isLgUp ? '1rem' : '0.6rem',
								}}
							>
								차트번호
							</TableCell>
							<TableCell
								sx={{
									fontSize: isLgUp ? '1rem' : '0.6rem',
								}}
							>
								{popupData.ChartNo}
							</TableCell>
							<TableCell
								sx={{
									backgroundColor: 'rgb(227, 242, 253)',
									textAlign: 'center',
									fontSize: isLgUp ? '1rem' : '0.6rem',
								}}
							>
								접수번호
							</TableCell>
							<TableCell
								sx={{
									fontSize: isLgUp ? '1rem' : '0.6rem',
								}}
							>
								{popupData.ReceptionRegNum}
							</TableCell>
						</TableRow>
					</TableBody>
				</Table>
				<Typography
					variant="body1"
					gutterBottom
				>
					* 접수항목
				</Typography>
				<Table
					size="small"
					sx={{ mb: 2, border: '1px solid rgba(224, 224, 224, 1)' }}
				>
					<colgroup>
						<col style={{ width: 95 }} />
						<col style={{ width: 170 }} />
						<col style={{ width: 95 }} />
						<col />
					</colgroup>
					<TableBody>
						<TableRow>
							<TableCell
								sx={{
									backgroundColor: 'rgb(227, 242, 253)',
									textAlign: 'center',
									fontSize: isLgUp ? '1rem' : '0.6rem',
								}}
							>
								검사코드
							</TableCell>
							<TableCell
								sx={{
									fontSize: isLgUp ? '1rem' : '0.6rem',
								}}
							>
								{popupData?.TestCode}
							</TableCell>
							<TableCell
								sx={{
									backgroundColor: 'rgb(227, 242, 253)',
									textAlign: 'center',
									fontSize: isLgUp ? '1rem' : '0.6rem',
								}}
							>
								검체명
							</TableCell>
							<TableCell
								sx={{
									fontSize: isLgUp ? '1rem' : '0.6rem',
								}}
							>
								{popupData?.SpecimenName}
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell
								sx={{
									backgroundColor: 'rgb(227, 242, 253)',
									textAlign: 'center',
									fontSize: isLgUp ? '1rem' : '0.6rem',
								}}
							>
								검사명
							</TableCell>
							<TableCell
								sx={{
									fontSize: isLgUp ? '1rem' : '0.6rem',
								}}
							>
								{popupData?.DisplayName}
							</TableCell>
							<TableCell
								sx={{
									backgroundColor: 'rgb(227, 242, 253)',
									textAlign: 'center',
									fontSize: isLgUp ? '1rem' : '0.6rem',
								}}
							>
								병리번호
							</TableCell>
							<TableCell
								sx={{
									fontSize: isLgUp ? '1rem' : '0.6rem',
								}}
							>
								{popupData?.PathologyNo ?? popupData?.ExtPathologyNo}
							</TableCell>
						</TableRow>
					</TableBody>
				</Table>
				<Typography
					variant="body1"
					gutterBottom
				>
					* Slide/Block 선택
				</Typography>

				<Box sx={{ width: '100%', typography: 'body1' }}>
					<TabContext value={value}>
						<Box
							sx={{
								borderBottom: 0,
								border: '1px solid #ccc',
								borderRight: 0,
							}}
						>
							<TabList
								onChange={handleChange}
								aria-label="lab API tabs example"
								sx={{
									backgroundColor: '#efefef',
									flexWrap: 'wrap',
									minHeight: '33px',
								}}
							>
								<Tab
									label="염색"
									value="1"
									sx={{
										backgroundColor: '#efefef',
										width: '25%',
										minHeight: '33px',
										borderRight: '1px solid #ccc',
										'&.Mui-selected': {
											color: 'rgb(75, 123, 236)',
											backgroundColor: 'rgb(227, 242, 253)',
										},
										fontSize: isLgUp ? '1rem' : '0.6rem',
										minWidth: isLgUp ? '25%' : 'auto',
									}}
								/>
								<Tab
									label="비염색"
									value="2"
									sx={{
										backgroundColor: '#efefef',
										width: '25%',
										minHeight: '33px',
										borderRight: '1px solid #ccc',
										'&.Mui-selected': {
											color: 'rgb(75, 123, 236)',
											backgroundColor: 'rgb(227, 242, 253)',
										},
										fontSize: isLgUp ? '1rem' : '0.6rem',
										minWidth: isLgUp ? '25%' : 'auto',
									}}
								/>
								<Tab
									label="세포"
									value="3"
									sx={{
										backgroundColor: '#efefef',
										width: '25%',
										minHeight: '33px',
										borderRight: '1px solid #ccc',
										'&.Mui-selected': {
											color: 'rgb(75, 123, 236)',
											backgroundColor: 'rgb(227, 242, 253)',
										},
										fontSize: isLgUp ? '1rem' : '0.6rem',
										minWidth: isLgUp ? '25%' : 'auto',
									}}
								/>
								<Tab
									label="블럭반출"
									value="4"
									sx={{
										backgroundColor: '#efefef',
										width: '25%',
										minHeight: '33px',
										borderRight: '1px solid #ccc',
										'&.Mui-selected': {
											color: 'rgb(75, 123, 236)',
											backgroundColor: 'rgb(227, 242, 253)',
										},
										fontSize: isLgUp ? '1rem' : '0.6rem',
										minWidth: isLgUp ? '25%' : 'auto',
									}}
								/>
							</TabList>
						</Box>
						<TabPanel
							value="1"
							sx={{ p: 0 }}
						>
							<TableContainer sx={{ height: 240 }}>
								<Table
									size="small"
									sx={{ mb: 2, border: '1px solid rgba(224, 224, 224, 1)' }}
									stickyHeader
								>
									<colgroup>
										<col style={{ width: 80 }} />
										<col />
										<col style={{ width: 80 }} />
									</colgroup>
									<TableHead>
										<TableRow>
											<TableCell sx={{ textAlign: 'center' }}>순번</TableCell>
											<TableCell sx={{ textAlign: 'center' }}>항목</TableCell>
											<TableCell sx={{ textAlign: 'center' }}>신청</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{tab1Dataset &&
											tab1Dataset.map((item: any, index: number) => {
												return item.Sequence >= 9000 && item.Sequence <= 9010 ? (
													<TableRow key={item.rowNum}>
														<TableCell sx={{ textAlign: 'center' }}>{index + 1}</TableCell>
														<TableCell>{item.DisplayName}</TableCell>
														<TableCell sx={{ textAlign: 'center' }}>
															{/*
												selectedSbList 에 동일한 rowNum이 없으면 신청버튼 활성화
												없으면 취소 버튼 활성화
												*/}
															{selectedSbList.findIndex(
																(x: any) => x.rowNum === item.rowNum,
															) === -1 ? (
																<Button
																	size="small"
																	color="success"
																	variant="contained"
																	onClick={() => onSBItemClick(item)}
																>
																	신청
																</Button>
															) : (
																<Button
																	size="small"
																	color="error"
																	variant="contained"
																	onClick={() => onSBItemClick(item)}
																>
																	취소
																</Button>
															)}
														</TableCell>
													</TableRow>
												) : (
													<></>
												)
											})}
									</TableBody>
								</Table>
							</TableContainer>
						</TabPanel>
						<TabPanel
							value="2"
							sx={{ p: 0 }}
						>
							<TableContainer sx={{ height: 240 }}>
								<Table
									size="small"
									sx={{ mb: 2, border: '1px solid rgba(224, 224, 224, 1)' }}
									stickyHeader
								>
									<colgroup>
										<col style={{ width: 80 }} />
										<col />
										<col style={{ width: 80 }} />
									</colgroup>
									<TableHead>
										<TableRow>
											<TableCell sx={{ textAlign: 'center' }}>순번</TableCell>
											<TableCell sx={{ textAlign: 'center' }}>항목</TableCell>
											<TableCell sx={{ textAlign: 'center' }}>신청</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{tab2Dataset &&
											tab2Dataset.map((item: any, index: number) => {
												return item.Sequence >= 9011 && item.Sequence <= 9022 ? (
													<TableRow key={item.rowNum}>
														<TableCell sx={{ textAlign: 'center' }}>{index + 1}</TableCell>
														<TableCell>{item.DisplayName}</TableCell>
														<TableCell sx={{ textAlign: 'center' }}>
															{/*
												selectedSbList 에 동일한 rowNum이 없으면 신청버튼 활성화
												없으면 취소 버튼 활성화
												*/}
															{selectedSbList.findIndex(
																(x: any) => x.rowNum === item.rowNum,
															) === -1 ? (
																<Button
																	size="small"
																	color="success"
																	variant="contained"
																	onClick={() => onSBItemClick(item)}
																>
																	신청
																</Button>
															) : (
																<Button
																	size="small"
																	color="error"
																	variant="contained"
																	onClick={() => onSBItemClick(item)}
																>
																	취소
																</Button>
															)}
														</TableCell>
													</TableRow>
												) : (
													<></>
												)
											})}
									</TableBody>
								</Table>
							</TableContainer>
						</TabPanel>
						<TabPanel
							value="3"
							sx={{ p: 0 }}
						>
							<TableContainer sx={{ height: 240 }}>
								<Table
									size="small"
									sx={{ mb: 2, border: '1px solid rgba(224, 224, 224, 1)' }}
									stickyHeader
								>
									<colgroup>
										<col style={{ width: 80 }} />
										<col />
										<col style={{ width: 80 }} />
									</colgroup>
									<TableHead>
										<TableRow>
											<TableCell sx={{ textAlign: 'center' }}>순번</TableCell>
											<TableCell sx={{ textAlign: 'center' }}>항목</TableCell>
											<TableCell sx={{ textAlign: 'center' }}>신청</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{tab3Dataset &&
											tab3Dataset.map((item: any, index: number) => {
												return item.Sequence >= 9027 && item.Sequence <= 9030 ? (
													<TableRow key={item.rowNum}>
														<TableCell sx={{ textAlign: 'center' }}>{index + 1}</TableCell>
														<TableCell>{item.DisplayName}</TableCell>
														<TableCell sx={{ textAlign: 'center' }}>
															{/*
												selectedSbList 에 동일한 rowNum이 없으면 신청버튼 활성화
												없으면 취소 버튼 활성화
												*/}
															{selectedSbList.findIndex(
																(x: any) => x.rowNum === item.rowNum,
															) === -1 ? (
																<Button
																	size="small"
																	color="success"
																	variant="contained"
																	onClick={() => onSBItemClick(item)}
																>
																	신청
																</Button>
															) : (
																<Button
																	size="small"
																	color="error"
																	variant="contained"
																	onClick={() => onSBItemClick(item)}
																>
																	취소
																</Button>
															)}
														</TableCell>
													</TableRow>
												) : (
													<></>
												)
											})}
									</TableBody>
								</Table>
							</TableContainer>
						</TabPanel>
						<TabPanel
							value="4"
							sx={{ p: 0 }}
						>
							<TableContainer sx={{ height: 240 }}>
								<Table
									size="small"
									sx={{ mb: 2, border: '1px solid rgba(224, 224, 224, 1)' }}
									stickyHeader
								>
									<colgroup>
										<col style={{ width: 80 }} />
										<col />
										<col style={{ width: 80 }} />
									</colgroup>
									<TableHead>
										<TableRow>
											<TableCell sx={{ textAlign: 'center' }}>순번</TableCell>
											<TableCell sx={{ textAlign: 'center' }}>항목</TableCell>
											<TableCell sx={{ textAlign: 'center' }}>신청</TableCell>
										</TableRow>
									</TableHead>
									<TableBody>
										{tab4Dataset &&
											tab4Dataset.map((item: any, index: number) => {
												return item.Sequence >= 9031 && item.Sequence <= 9032 ? (
													<TableRow key={item.rowNum}>
														<TableCell sx={{ textAlign: 'center' }}>{index + 1}</TableCell>
														<TableCell>{item.DisplayName}</TableCell>
														<TableCell sx={{ textAlign: 'center' }}>
															{/*
												selectedSbList 에 동일한 rowNum이 없으면 신청버튼 활성화
												없으면 취소 버튼 활성화
												*/}
															{selectedSbList.findIndex(
																(x: any) => x.rowNum === item.rowNum,
															) === -1 ? (
																<Button
																	size="small"
																	color="success"
																	variant="contained"
																	onClick={() => onSBItemClick(item)}
																>
																	신청
																</Button>
															) : (
																<Button
																	size="small"
																	color="error"
																	variant="contained"
																	onClick={() => onSBItemClick(item)}
																>
																	취소
																</Button>
															)}
														</TableCell>
													</TableRow>
												) : (
													<></>
												)
											})}
									</TableBody>
								</Table>
							</TableContainer>
						</TabPanel>
					</TabContext>
				</Box>
				<Typography
					variant="body1"
					gutterBottom
				>
					* 신청항목
				</Typography>
				<TableContainer sx={{ maxHeight: 100 }}>
					<Table
						size="small"
						sx={{ mb: 2, border: '1px solid rgba(224, 224, 224, 1)' }}
						stickyHeader
					>
						<colgroup>
							<col style={{ width: 80 }} />
							<col />
						</colgroup>
						<TableHead>
							<TableRow>
								<TableCell sx={{ textAlign: 'center' }}>순번</TableCell>
								<TableCell sx={{ textAlign: 'center' }}>신청항목</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{selectedSbList &&
								selectedSbList.map((item: any, index: number) => (
									<TableRow key={index}>
										<TableCell sx={{ textAlign: 'center' }}>{index + 1}</TableCell>
										<TableCell>{item.DisplayName}</TableCell>
									</TableRow>
								))}
							{selectedSbList.length === 0 && (
								<TableRow>
									<TableCell
										colSpan={2}
										sx={{ textAlign: 'center' }}
									>
										신청항목이 없습니다.
									</TableCell>
								</TableRow>
							)}
						</TableBody>
					</Table>
				</TableContainer>
				<Typography
					variant="body1"
					gutterBottom
				>
					비고
				</Typography>
				<TextField
					multiline
					fullWidth
					rows={3}
					variant="outlined"
					sx={{ mb: 2 }}
					value={popupData?.RequestNotes}
					onChange={(e) => {
						setPopupData({
							...popupData,
							RequestNotes: e.target.value,
						})
					}}
				/>
				<Typography
					variant="body2"
					sx={{ mb: 1 }}
					style={{ color: 'blue' }}
				>
					수령 일정 문의 : 영업 담당자
					<br />
					수정 및 취소 문의 : 병리학부 (02-801-5135/5137){' '}
				</Typography>
				{/*Slide/Block의 수령 일정은 영업 담당자에게 문의 바랍니다.<br/>신청 취소 및 수정은 병리학부(02-801-5135/5137) 로 문의 바랍니다.				</Typography>*/}
				<FormControlLabel
					control={
						<Checkbox
							value={popupData?.agree}
							onChange={() => {
								setPopupData({
									...popupData,
									agree: !popupData?.agree,
								})
							}}
						/>
					}
					label="확인했습니다."
				/>
			</DialogContent>
			<Divider />
			<DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
				<Button
					variant="contained"
					color="success"
					onClick={onPopupSubmit}
				>
					신청
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default SlideBlockPopup
